import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from 'react-bootstrap/Button';
import Alert from "react-bootstrap/Alert";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { useState, useContext } from "react";
import APIPostFailed from "../../APIFailed/APIPostFailed";
import { useHistory } from "react-router";

import * as yup from 'yup';
import { Formik } from "formik";
import { authService } from "../../services/auth-service";
import { LoginContext } from "../../services/LoginContext";
import { InputGroup } from "react-bootstrap";

function UploadScheduleFile(props) {

    let schema = yup.object().shape({
        fileName: yup.string().required("Это поле не может быть пустым.").max(50, "Превышен лимит из 50 символов."),
        file: yup.mixed().test("Required", "Выберите файл.", value => value !== null).test("Тип MIME", "Тип файла не поддерживается", (value, context) => value?.type.startsWith("image/") || value?.type.startsWith("application/"))
    });

    const history = useHistory()
    const setLoggedIn = useContext(LoginContext)[1]
    let [fetchFailed, setFetchFailed] = useState(false);
    let [errorMsg, setErrorMsg] = useState("");

    const submitScheduleFile = (formData, setSubmitting) => {

        setFetchFailed(false);
        setErrorMsg("");
        fetch(`${process.env.REACT_APP_API_URL}/schedulefile`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authService.authHeader()
            },
            body: JSON.stringify({ fileName: `${formData.fileName}.${formData.file.name.split('.').pop()}` })
        })
            .then(response => response.json().then(data => ({ status: response.status, data: data })))
            .then(({ status, data }) => {
                setSubmitting(false);
                if (status === 201) {
                    fetch(data.s3object.url, {
                        method: 'PUT',
                        mode: 'cors',
                        body: formData.file
                    }).then(s3response => {
                        if (s3response.ok) {
                            let currDate = new Date();
                            props.createToast({
                                title: "Обновить файл расписаний",
                                time: `${currDate.getHours()}:${('0' + currDate.getMinutes()).slice(-2)}`,
                                message: "Файл расписаний был успешно обновлен",
                                show: true
                            });
                            history.push('/siteadmin/home')
                        }
                    });
                } else if (status === 401) {
                    authService.logout()
                        .then(() => setLoggedIn(false))
                } else {
                    setFetchFailed(true)
                    setErrorMsg(data.error || "Произошла неизвестная ошибка.")
                }
            })
            .catch(err => {
                setSubmitting(false)
                setFetchFailed(true)
                setErrorMsg("Произошла неизвестная ошибка.")
                console.log(err)
            })
    }

    return (
        <Container className="siteadmin-action-container">
            <h1 className="siteadmin-action-heading">Обновить файл расписаний</h1>
            <Alert variant="primary">
                <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: "1.5rem" }} />
                <span style={{ paddingLeft: "1.5rem" }}>Добавленный файл расписания заменит текущий файл во вкладке «Информация»</span>
            </Alert>
            <Formik
                validateOnBlur={true}
                validationSchema={schema}
                onSubmit={(values, { setSubmitting }) => submitScheduleFile(values, setSubmitting)}
                initialValues={{
                    fileName: "",
                    file: null
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    values,
                    touched,
                    isSubmitting,
                    errors
                }) => (
                    <Form noValidate onSubmit={handleSubmit} style={{ marginBottom: "1rem" }}>
                         <Form.Group>
                            <Form.Label>Прикрепите файл</Form.Label>
                            <Form.Control
                                type="file"
                                name="file"
                                onChange={evt => {
                                    if (evt.currentTarget.files[0]) {
                                        console.log(evt.currentTarget.files[0]);
                                        setFieldValue("file", evt.currentTarget.files[0], true)
                                        setFieldValue("fileName", evt.currentTarget.files[0].name.split(".").slice(0, -1).join("."), true)
                                    } else {
                                        setFieldValue("file", null, true)
                                        setFieldValue("fileName", "", true)
                                    }
                                }}
                                onBlur={handleBlur}
                                isInvalid={!!errors.file && touched.file}
                            />
                            <Form.Control.Feedback type="invalid">{errors.file}</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="fileName" className="mt-2">
                            <Form.Label>Название файла</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    name="fileName"
                                    placeholder="Измените название файла (необязательно)"
                                    defaultValue={values.fileName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isValid={touched.fileName && !errors.fileName}
                                    isInvalid={!!errors.fileName} />
                                <InputGroup.Text>{'.' + (values.file?.name.split(".").at(-1) ?? '')}</InputGroup.Text>
                            </InputGroup>
                            <Form.Control.Feedback type="invalid">{errors.fileName}</Form.Control.Feedback>
                        </Form.Group>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ?
                                <span>Загрузка <Spinner as="span" animation="border" size="sm" role="status" /></span>
                                : 'Обновить'
                            }
                        </Button>
                    </Form>
                )}
            </Formik>
            {fetchFailed && <APIPostFailed message={errorMsg} />}
        </Container>
    )
}

export default UploadScheduleFile;